module.exports = __webpack_public_path__ + "static/media/6.cca2fbf0.webp";